import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ClearancelevelEnum } from 'src/app/constants/clearance-levels.enum';
import { RequestModel } from 'src/app/models/requests';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ClipboardService } from 'src/app/services/clipboard.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-reviewandsendsummaryitem',
  templateUrl: './reviewandsendsummaryitem.component.html'
})
export class ReviewandsendsummaryitemComponent implements OnInit {

  get request(): RequestModel {
    return this._request;
  }
  @Input('request') set request(val: RequestModel) {
    this._request = val
    // workgroup is the unique identifier (guid) of a workgroup 
    if(this._request.workgroup != null && this._request.workgroup != undefined){
      let workgroup = this.authenticationService.workgroups.find(workgroup => workgroup.Guid === this._request.workgroup);
      if(workgroup == null || workgroup == undefined) return;
      this.MaxClearanceOfWorkgroup = (workgroup?.Clearancelevel as ClearancelevelEnum)
      if(this._request.workgroupName == null || this._request.workgroupName == undefined){
        this._request.workgroupName = workgroup.Name;
      }
    }
  }
  private _request!: RequestModel;
  @Input() requestType!: string;
  translations: any = <any>{};
  MaxClearanceOfWorkgroup: number = ClearancelevelEnum.One;
  
  constructor(private translateService: TranslateService, private toastService: ToastService, private clipboardService: ClipboardService, private authenticationService: AuthenticationService) {
    // Must not be empty. It's approved by a comment.
  }
  
  ngOnInit(): void {
    this.getTranslations();
    this.translateService.onLangChange.subscribe(() => {
      this.getTranslations();
    });
  }

  getTranslations() {
    this.translateService.get([
      'Toasts.ClipboardError',
      'Toasts.ClipboardNotSupported',
      'Toasts.Error'
    ]).subscribe(translation => {
      this.translations.toastsClipboardError = translation['Toasts.ClipboardError'];
      this.translations.toastsClipboardNotSupported = translation['Toasts.ClipboardNotSupported'];
      this.translations.error = translation['Toasts.Error'];
    });
  }

  async copyToClipboard() {
    try {
      if (!navigator.clipboard) {
        this.toastService.showError(this.translations.error, this.translations.toastsClipboardNotSupported);
      }
      await this.clipboardService.Copy(this.request.id);
      this.toastService.showCopied();
    }
    catch (error: any) {
      this.toastService.showError(this.translations.error, this.translations.toastsClipboardError);
    }
  }
  MaxClearnaceIsNotOne(){
    return this.MaxClearanceOfWorkgroup != ClearancelevelEnum.One;
  }
}
